<template>
  <ListeReferentiel
    ref="liste"
    titre="Utilisateurs"
    icone="bi-people"
    ressource="users"
    tri-defaut="user.nom"
    :options-tri="{ Nom: 'user.nom', Prénom: 'user.prenom', Identifiant: 'user.username', 'E-mail': 'user.email', Rôle: 'tu.nom', Statut: 'user.enabled', 'Date de création': 'user.createdAt' }"
    placeholder="Nom, prénom, identifiant, e-mail, téléphone…"
    unite="utilisateur(s)"
    vide="Aucun utilisateur enregistré."
    :colonnes="8"
    :filtres="{ typeUser, sansSuperAdmin: 1 }"
    :peut-creer="$store.getters.hasPermission('ADMIN_CREATION_UTILISATEUR')"
    libelle-creer="Nouvel utilisateur"
    @creer="creation"
  >
    <template #filtres>
      <div class="col-6 col-md-2">
        <label class="form-label fw-semibold small mb-1">Rôle</label>
        <select v-model="typeUser" class="form-select form-select-clinique">
          <option value="">Tous</option>
          <option v-for="t in roles" :key="t.id" :value="t.id">{{ t.nom }}</option>
        </select>
      </div>
    </template>
    <template #entete>
      <th>Nom</th>
      <th class="d-none d-md-table-cell">Identifiant</th>
      <th class="d-none d-lg-table-cell">E-mail</th>
      <th>Contact</th>
      <th>Rôle</th>
      <th>Statut</th>
      <th>Actions</th>
    </template>
    <template #ligne="{ ligne: user }">
      <td>{{ user.prenom }} {{ user.nom }}</td>
      <td class="d-none d-md-table-cell">{{ user.username }}</td>
      <td class="d-none d-lg-table-cell">{{ user.email || '—' }}</td>
      <td>
        <template v-if="user.telephone">
          <a :href="telLink(user.telephone)" class="btn btn-sm btn-outline-primary me-1" title="Appeler"><i class="bi bi-telephone-fill"></i></a>
          <a :href="whatsappLink(user.telephone)" target="_blank" rel="noopener noreferrer" class="btn btn-sm btn-outline-success" title="Écrire sur WhatsApp"><i class="bi bi-whatsapp"></i></a>
        </template>
        <span v-else class="text-muted">—</span>
      </td>
      <td>{{ user.typeUser?.nom || 'Non défini' }}</td>
      <td>
        <span :class="['badge', user.enabled ? 'bg-success' : 'bg-secondary']">{{ user.enabled ? 'Activé' : 'Désactivé' }}</span>
      </td>
      <td>
        <div v-if="$store.getters.hasAnyPermission(['ADMIN_EDIT_UTILISATEUR', 'ADMIN_DESACTIVER_UTILISATEUR', 'ADMIN_SUPPRESSION_UTILISATEUR'])" class="dropdown">
          <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" v-dropdown-fixed>Actions</button>
          <ul class="dropdown-menu">
            <li v-if="$store.getters.hasPermission('ADMIN_EDIT_UTILISATEUR')"><a class="dropdown-item" href="#" @click.prevent="modifier(user.id)">Modifier</a></li>
            <li v-if="$store.getters.hasPermission('ADMIN_DESACTIVER_UTILISATEUR')"><a class="dropdown-item" href="#" @click.prevent="changerStatus(user)">{{ user.enabled ? 'Désactiver' : 'Activer' }}</a></li>
            <li v-if="$store.getters.hasPermission('ADMIN_SUPPRESSION_UTILISATEUR')"><a class="dropdown-item text-danger" href="#" @click.prevent="supprimer(user)">Supprimer</a></li>
          </ul>
        </div>
      </td>
    </template>
  </ListeReferentiel>
</template>

<script>
import api, { messageErreur, notifier } from '@/api';
import ListeReferentiel from '@/components/commun/ListeReferentiel.vue';
import { confirmer } from '@/components/commun/dialogue';

export default {
  name: 'ListeUser',
  components: { ListeReferentiel },
  data() {
    return { typeUser: '', roles: [] };
  },
  async created() {
    try {
      const res = await api.getItems('type_users', { orderBy: 'tu.nom', sortOrder: 'asc' });
      this.roles = (res.data?.data || []).filter(t => String(t.nom || '').trim().toLowerCase() !== 'super admin');
    } catch {
      this.roles = [];
    }
  },
  methods: {
    creation() {
      this.$router.push({ name: 'create_utilisateur' });
    },
    modifier(id) {
      this.$router.push({ name: 'edit_user', params: { id } });
    },
    numeroInternational(telephone) {
      let num = String(telephone).replace(/[\s()-]/g, '');
      if (num.startsWith('+')) return num.substring(1);
      if (num.startsWith('00')) return num.substring(2);
      // Numéro local : indicatif par défaut du déploiement
      const indicatif = process.env.VUE_APP_DEFAULT_COUNTRY_CODE;
      if (indicatif && !num.startsWith(indicatif)) num = indicatif + num;
      return num;
    },
    whatsappLink(telephone) {
      return telephone ? `https://wa.me/${this.numeroInternational(telephone)}` : null;
    },
    telLink(telephone) {
      if (!telephone) return null;
      const brut = String(telephone).replace(/[\s()-]/g, '');
      const international = brut.startsWith('+') || brut.startsWith('00') || process.env.VUE_APP_DEFAULT_COUNTRY_CODE;
      return international ? `tel:+${this.numeroInternational(telephone)}` : `tel:${brut}`;
    },
    supprimer(user) {
      this.$refs.liste.supprimer({
        id: user.id,
        titre: "Supprimer l'utilisateur",
        message: `Supprimer le compte de ${user.prenom || ''} ${user.nom || ''} ? Pour garder son historique, préférez « Désactiver ».`,
        succes: 'Utilisateur supprimé.',
      });
    },
    async changerStatus(user) {
      if (user.enabled) {
        const ok = await confirmer({
          titre: "Désactiver l'utilisateur",
          message: `${user.prenom || ''} ${user.nom || ''} ne pourra plus se connecter. Continuer ?`,
          libelleValider: 'Désactiver',
          danger: true,
        });
        if (!ok) return;
      }
      try {
        await api.patchMergeItem('users', user.id, { enabled: !user.enabled });
        notifier(user.enabled ? 'Utilisateur désactivé.' : 'Utilisateur activé.', 'success');
        this.$refs.liste.charger();
      } catch (error) {
        if (error?.response?.status !== 403) notifier(messageErreur(error, "Le statut n'a pas pu être changé."), 'danger');
      }
    },
  },
};
</script>
